<script lang="ts">
  import '../../gettext'
  import config from 'config'
  import Navigation from './Navigation.svelte'
  import SearchIcon from 'images/icon-search-header.png'
  import DataBasinLogo from 'images/logo-databasin.svg?file'

  let searchInput: HTMLInputElement | null = null

  let databasinLink = 'https://databasin.org'
  if (config.gateway && window.location.hostname.startsWith(config.gateway)) {
    databasinLink = `${window.location.protocol}//${window.location.hostname.substring(
      (config.gateway.length as number) + 1,
    )}${window.location.port ? ':' + window.location.port : ''}`
  }

  const handleSearch = (e: Event) => {
    const query = searchInput?.value?.trim()

    if (query) {
      window.location.href = `/search/#query=${query}`
    } else {
      window.location.href = '/search/'
    }

    e.preventDefault()
    return false
  }
</script>

<header>
  <div class="header-content">
    <svelte:component this={config.logoComponent} />

    <div class="search-container">
      <form on:submit={handleSearch}>
        <div class="search">
          <label>
            <span class="sr-only">{window.gettext('Search by keyword or location')}</span>
            <input type="text" placeholder={window.gettext('Search by keyword or location')} bind:this={searchInput} />
          </label>
          <button type="submit" role="button" aria-label="Search">
            <img src={SearchIcon} aria-hidden="true" alt={window.gettext('Search')} />
          </button>
        </div>
      </form>

      {#if config.gateway}
        <a href={databasinLink} class="powered-by">powered by <img src={DataBasinLogo} alt="Data Basin" /></a>
      {/if}
    </div>
  </div>

  <Navigation />
</header>

<style lang="scss">
  header {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .header-content {
      display: flex;
      justify-content: space-between;
      background: $header-background;
      width: calc(#{$content-width} - 2px);
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      border: 1px solid $gray-7;
      border-bottom: none;

      .search-container {
        margin: 16px 14px;
      }

      .search {
        position: relative;

        input {
          border: 1px solid $gray-7;
          border-radius: 6px;
          padding: 6px 31px 6px 3px;
          width: 164px;
          font-size: 11px;
          box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        button {
          position: absolute;
          right: 0;
          top: 0;
          margin-top: 1px;
          background: none;
          border: none;
          cursor: pointer;
        }
      }

      .powered-by,
      .powered-by:visited {
        display: block;
        text-decoration: none;
        font-size: 12px;
        margin-top: 15px;
        color: $primary-0;
        text-align: right;
        padding: 2px 5px;
        background: $header-powered-by-background;
        border-radius: 6px;

        img {
          width: 118px;
          height: 27px;
          margin-left: 5px;
          vertical-align: middle;
        }
      }
    }
  }
</style>
